<script setup lang="ts">
import "@maersk-global/mds-components-core/mc-card";
import { onMounted, shallowRef } from "vue";
import { getAccessToken, getUserEmail, getUserName, initializeMSAL } from "@/auth";
import { useGlobalStore } from "@/store/global";
import UserMenu from "@/components/UserMenu.vue";
import AppNav from "@/components/AppNav.vue";

const isAuthenticating = shallowRef(true);
const isAuthError = shallowRef(false);

onMounted(async () => {
  try {
    await initializeMSAL();

    isAuthenticating.value = false;

    const token = getAccessToken();
    isAuthError.value = !token;

    if (token) {
      const gs = useGlobalStore();
      gs.userName = getUserName();
      gs.userEmail = getUserEmail();
    }
  } catch (error: any) {
    console.error("[App] initializeMSAL failed:", error);
    isAuthenticating.value = false;
    isAuthError.value = true;
  }

  if (isAuthError.value) {
    setTimeout(() => (window.location.href = "/"), 3000);
  }
});
</script>

<template>
  <div v-if="isAuthenticating" class="app-auth-overlay">
    <span class="app-auth-overlay__message">Authenticating…</span>
  </div>

  <div v-else-if="isAuthError" class="app-auth-overlay">
    <mc-card
      style="width: 460px"
      image="./assets/maersk-logo.svg"
      heading="Authentication failed"
      footer="Retrying in a few seconds…"
      contentalignment="middle"
      orientation="horizontal"
      imagepercent="14"
      variant="bordered"
      padding="16px"
    />
  </div>

  <template v-else>
    <header class="app-header">
      <div class="app-header__brand">
        <img src="/assets/maersk-logo.svg" alt="Maersk" class="app-header__logo" />
      </div>
      <div class="app-header__right">
        <UserMenu />
      </div>
    </header>
    <AppNav />
    <main class="app-content">
      <router-view />
    </main>
  </template>
</template>

<style scoped lang="scss">
.app-auth-overlay {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;

  &__message {
    font-size: 16px;
    color: #555;
  }
}

.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;

  &__brand {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__logo {
    height: 28px;
    width: auto;
  }

  &__right {
    display: flex;
    align-items: center;
  }
}

.app-content {
  padding-top: 116px;
  padding-bottom: 48px;
  max-width: 1312px;
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;
}
</style>
